import React from 'react';
import {
  fetchReportPayload,
  getExportReportPayload,
  savedQueryMapper,
} from '../../../../Utils/ReportPortalUtils/ReportPayloadUtils';
import ReportViewContainer from '../../../../Containers/ReportPortalContainer/ReportViewContainer/ReportViewContainer';
import styles from './RecruiterReports.module.scss';
import TextWithInfoIcon from '../../../Common/TextWithInfoIcon/TextWithInfoIcon';

export default function RecruiterReports(props) {
  const {
    reportStats,
    getReportStats: fetchReportStats,
    fetchReportStatsApiStatus,
    exportReportApiStatus,
    savedQueryConfig,
    onSaveQuerySuccess,
  } = props;

  const getReportStats = (filter, page, pageSize) => {
    const fetchPayloadCriteria = { filter, page, pageSize, reportKey: 'recruiters' };
    const recruiterReportFetchPayload = fetchReportPayload(fetchPayloadCriteria);

    fetchReportStats(recruiterReportFetchPayload, 'recruiters');
  };

  React.useEffect(() => {
    if (savedQueryConfig?.runSavedQueryFlag) {
      const savedQuery = JSON.parse(savedQueryConfig?.queryDetails?.ReportQuery);
      const mappedSavedQuery = savedQueryMapper(savedQuery, savedQueryConfig?.queryDetails?.dynamicReportColumns);
      getReportStats(mappedSavedQuery, 1, 10);
    }
  }, [savedQueryConfig?.runSavedQueryFlag]);

  return (
    <div className={styles.recruiterReports}>
      <ReportViewContainer
        fetchReportStatsApiStatus={fetchReportStatsApiStatus}
        title="Recruiter Report"
        subtitle={
          <TextWithInfoIcon
            text="Report based on Recruiter Activity during the date(s) given"
            tooltipTitle="Latest results may be delayed 1-2 hours"
          />
        }
        type="recruiters"
        filterConfig={{ job: false, client: false }}
        reportStats={reportStats}
        getReportStats={getReportStats}
        exportReportApiStatus={exportReportApiStatus}
        savedReportDetails={savedQueryConfig?.queryDetails}
        onSaveQuerySuccess={onSaveQuerySuccess}
      />
    </div>
  );
}
